import { render, staticRenderFns } from "./EbgSystemUserGroups.vue?vue&type=template&id=21c819d5&scoped=true"
import script from "./EbgSystemUserGroups.js?vue&type=script&lang=js&external"
export * from "./EbgSystemUserGroups.js?vue&type=script&lang=js&external"
import style0 from "./EbgSystemUserGroups.scss?vue&type=style&index=0&id=21c819d5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c819d5",
  null
  
)

export default component.exports